import { useWindowWide } from "@/hooks/useWindowWide";
import "./App.css";
import Routes from "@/components/Routes";
import { size } from "@/utils/responsive";

function App() {
  const width = useWindowWide(size.notSupportNum);
  return (
    <div>
      {width ? (
        <Routes />
      ) : (
        <div
          style={{
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <p> We Do Not Support Your Device</p>
          <p> Sorry for Inconvinence</p>
        </div>
      )}
    </div>
  );
}

export default App;
